var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('h1',{staticClass:"blue--text"},[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.count))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }